import { render, staticRenderFns } from "./ProjectSoftwares.vue?vue&type=template&id=6542d99a&scoped=true&"
import script from "./ProjectSoftwares.vue?vue&type=script&lang=js&"
export * from "./ProjectSoftwares.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSoftwares.vue?vue&type=style&index=0&id=6542d99a&scoped=true&lang=css&"
import style1 from "./ProjectSoftwares.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6542d99a",
  null
  
)

export default component.exports